
import {COLOR} from '../const';


var React = require('react');
var Radium = require('radium');

const Label = ({italic = true, color = "white", text="label", centered = false, style}) => {

  let cls = [styles.label,styles.italic];

  switch (color) {
    case "white":
      cls.push(styles.white);
      break;
    case "blue":
      cls.push(styles.blue);
      break;
    case "green":
      cls.push(styles.green);
      break;
    case "gray":
      cls.push(styles.gray);
      break;
    default:
      cls.push(styles.white);
      break;
  }

  if (centered){
    cls.push(styles.centered);
  }

  if (style) {
    cls.push(style);
  }

  return(
    <p style={cls}>{text}</p>
  )
}

const styles = {
  label: {
    fontSize: '15px',
    textAlign: 'left',
  },
  centered:{
    textAlign: 'center',
  },
  italic: {
    fontStyle: 'italic',
  },
  white: {
    color: COLOR.white,
  },
  blue: {
    color: COLOR.blue,
  },
  green: {
    color: COLOR.green,
  },
  green: {
    color: COLOR.grayText,
  },
}

export default Radium(Label);



// WEBPACK FOOTER //
// ./src/comp/Label.js